/**
 * TBD
 */ export var FAIRE_DIRECT_CREDIT_EXPIRES_IN_DAYS = 'FAIRE_DIRECT_CREDIT_EXPIRES_IN_DAYS';
